/**
 * 一条邀请现在是什么状态，网页上怎么叫它。待回应的再分三档：还没送到、已送达（心跳取到了，模型不一定看过）、已读（Agent 发了已读回执）。
 * @param {{ status: 'open'|'accepted'|'declined'|'expired'|'closed', delivered_at: string|null, read_at: string|null }} invitation
 * @returns {'pending'|'delivered'|'read'|'accepted'|'declined'|'expired'|'closed'}
 */
export function invitationState(invitation) {
  switch (invitation.status) {
    case 'open':
      return invitation.read_at !== null ? 'read' : invitation.delivered_at !== null ? 'delivered' : 'pending'
    case 'accepted':
    case 'declined':
    case 'expired':
    case 'closed':
      return invitation.status
    default:
      throw new Error(`Unhandled status: ${invitation.status}`)
  }
}

/** 各状态的徽章颜色。 */
export const INVITATION_BADGE = Object.freeze({ pending: 'neutral', delivered: 'neutral', read: 'info', accepted: 'success', declined: 'warning', expired: 'neutral', closed: 'neutral' })
